import { ActionStack, MessagePage } from '../components/common';
import { MessagePatricia } from './MessagePatricia';

/**
 * The door when the edge has rate-limited this connection (a 429 from
 * `/api/portal/invite/:token`). The link is very likely fine — a household on
 * one wifi, a mail scanner, a retry loop — so this page must not say anything
 * about the link. "Not one of ours" here would send a customer to Patricia to
 * be issued a fresh link they never needed.
 */
export function JoinBusy() {
  return (
    <MessagePage
      title="Give it a minute"
      lead="Too many links have been opened from this connection just now. Wait a minute, then open your link again. Nothing has happened to it."
      actions={
        <ActionStack>
          <MessagePatricia />
        </ActionStack>
      }
    />
  );
}
